import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDinersClubCardLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 24,
	viewBox: "0 0 34 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.8387 19.3H18.4348C22.4872 19.3 25.7165 16.085 25.8432 12.1135V12.0504C25.7798 8.0159 22.4872 4.73784 18.4348 4.80088H15.5221C11.6597 4.92696 8.62034 8.20502 8.74698 12.1135C8.74698 16.0219 11.9129 19.2369 15.8387 19.3ZM10.0134 12.0504C10.0134 8.77235 12.7361 6.06165 16.0287 6.06165C19.3213 6.06165 22.044 8.77235 22.044 12.0504C22.044 15.3285 19.3213 18.0392 16.0287 18.0392C12.7361 18.0392 10.0134 15.3285 10.0134 12.0504ZM16.9785 16.0849V8.07892C19.1947 8.64627 20.5877 10.8527 20.0178 13.059C19.6379 14.572 18.4981 15.7067 16.9785 16.0849ZM12.1029 11.0418C11.533 13.2482 12.8627 15.5176 15.0789 16.0849V8.07892C13.6226 8.45716 12.4828 9.59187 12.1029 11.0418Z",
			fill: "#0079BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z",
			fill: "#F2F4F7"
		})
	]
});
export default SvgDinersClubCardLogo;
